// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__nt+zU","filler":"Tabs_filler__wCoTR","tabList":"Tabs_tabList__0FJcw","link":"Tabs_link__H79Bg","tab":"Tabs_tab__IMJ79","linkActive":"Tabs_linkActive__+zgUw"};